import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, ViewChild } from '@angular/core';
import { DialogComponent } from '@vsolv/vectors-ui/dialog';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-remove-payment-method-dialog',
  templateUrl: './remove-payment-method.dialog.html',
  standalone: false,
})
export class RemovePaymentMethodDialog {
  @HostBinding('class') protected _classes = 'contents';

  @ViewChild(DialogComponent) private dialog?: DialogComponent;

  @Input() submitting = false;
  @Output() confirmed = new EventEmitter<void>();

  open() {
    this.dialog?.open();
  }

  close() {
    this.dialog?.close();
  }

  protected confirm() {
    if (this.submitting) return;

    this.confirmed.emit();
  }
}
